/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PccPatientResponseRaceInner
 */
export interface PccPatientResponseRaceInner {
    /**
     * 
     */
    raceDesc?: string;
}

/**
 * Check if a given object implements the PccPatientResponseRaceInner interface.
 */
export function instanceOfPccPatientResponseRaceInner(value: object): value is PccPatientResponseRaceInner {
    return true;
}

export function PccPatientResponseRaceInnerFromJSON(json: any): PccPatientResponseRaceInner {
    return PccPatientResponseRaceInnerFromJSONTyped(json, false);
}

export function PccPatientResponseRaceInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccPatientResponseRaceInner {
    if (json == null) {
        return json;
    }
    return {
        
        'raceDesc': json['raceDesc'] == null ? undefined : json['raceDesc'],
    };
}

export function PccPatientResponseRaceInnerToJSON(json: any): PccPatientResponseRaceInner {
    return PccPatientResponseRaceInnerToJSONTyped(json, false);
}

export function PccPatientResponseRaceInnerToJSONTyped(value?: PccPatientResponseRaceInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'raceDesc': value['raceDesc'],
    };
}

